export function PdfRow({ row, titles }) {
    return (
        <div className='pdf-row'>
            {titles.map((item, i) => <div key={i} className="row-cell">{row[item]}</div>)}
        </div>
    )
}